import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    RESET,
    SET as patientSET
} from 'one-state-subject/src/types';

import {
    setAction,
    reinitAction
} from 'one-state-incidents/src/actions';

import { Disposition } from 'one-model-local';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';


export const enum Types {
    SETINCIDENTDATA = 'one-state-incidents/fetch',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });



/**
 * This Fuction will fetch the data of incidents epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchIncidentsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { log, server, agentId,teamName, settings: {
            epicendpoints: {
                getincidents,
                apitoken,
            }, 
            compatible,
            uisettings: {
                dashboardapiconfig: {
                    getincidents : getincidentsApi
                }
            },
        }} = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
           ofType(Types.SETINCIDENTDATA),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        // todo: need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            sysparm_query: `opened_for.email=${datares.email}`,
                            sysparm_display_value: true,
                            sysparm_exclude_reference_link: true,
                            sysparm_fields: 'number,short_description,description,priority,state,category,sys_created_on,sys_id,opened_for,caller_id,opened_by,opened_at',
                          }
                        const response = server.post({
                            path: getincidents,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,incidents-epic",
                                    "fetch-Incidents-epic", {
                                    responseresult
                                }
                                );

                                let errorbuild: ErrorObject = {
                                    source: "Incidents",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!getincidentsApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response)];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                
                            } 
                            if(response?.error){
                                /*changes for errors will pushed to bell icon*/
                                     let errorbuild:ErrorObject = {
                                    source: "SN-Incidents",
                                    type: "error",
                                    status: response?.status,
                                    erroritems: response?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                actions.push(addAction(errorbuild))
                                let disp: Disposition = { value: "1013" }
                                 if (contact_center_type && contact_center_type === 'five9') {
                                     let agentIdValue = sessionStorage.getItem("agentName");
                                     let skillName = sessionStorage.getItem("skillName");
                                     disp.meta00 = agentIdValue;
                                     disp.meta01 = skillName;
                                     disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                 } 
                                 else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                 else {
                                     disp.meta00 = agentId;
                                     disp.meta01 = teamName;
                                     disp.dial_list_uid = state$.value.choosecaller?.callId;
                                 }
                                 disp.meta03 = response?.error?.status;
                                 disp.meta02 = dataresponse.opened_for;
                                 actions.push(pushToDisposition(disp));
                                 } else {
                                     let disp: Disposition = { value: "197" }
                                     if (contact_center_type && contact_center_type === 'five9') {
                                         let agentIdValue = sessionStorage.getItem("agentName");
                                         let skillName = sessionStorage.getItem("skillName");
                                         disp.meta00 = agentIdValue;
                                         disp.meta01 = skillName;
                                         disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                     } 
                                     else if(contact_center_type==="genesys"){
                                        disp.meta00 = sessionStorage.getItem("name");
                                        disp.meta01 = sessionStorage.getItem("agentName");
                                      }
                                      else if(contact_center_type==="twilio"){
                                        disp.meta00 = sessionStorage.getItem("twilio_userid");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="ringcentral"){
                                        disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="inContact"){
                                        disp.meta00 = sessionStorage.getItem("agentName");
                                        disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                      }
                                      else if(contact_center_type==="vonage"){
                                        disp.meta00 = sessionStorage.getItem("vonage_userid");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="wxcc"){
                                        disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                        disp.meta01 = "";
                                      } 
                                     else {
                                         disp.meta00 = agentId;
                                         disp.meta01 = teamName;
                                         disp.dial_list_uid = state$.value.choosecaller?.callId;
                                     }
                                     disp.meta02 = dataresponse.opened_for;
                                     actions.push(pushToDisposition(disp));
                                 }
                            return actions;
                        })
                        // map((response: any) => setAction(response))
                    )
            })
        )
    }
);
/**
 * This Fuction will clear data of pending referals epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearIncidentsEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,incidents-epic",
            "Reset-Referrals-epic", {
        });
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);

